<template>
  <div id="home">
    <template v-if="$store.getters.loggedUser">
      <div id="recent-items">
        <h3 class="mb-3">
          <router-link tag="span" :to="{ name: ROUTE_FOOD }">{{
            $t("food.recent")
          }}</router-link>
        </h3>

        <transition-group mode="out-in" name="move" tag="div" class="row">
          <FoodCard
            v-for="keyObj in sortedFoodKeys"
            :key="keyObj.key"
            :id="keyObj.key"
            :foodItem="food[keyObj.key]"
          ></FoodCard>
        </transition-group>

        <h3 class="mb-3">
          <router-link tag="span" :to="{ name: ROUTE_CATEGORIES }">{{
            $t("categories.recent")
          }}</router-link>
        </h3>

        <transition-group mode="out-in" name="move" tag="div" class="row">
          <CategoryCard
            v-for="keyObj in sortedCategoriesKeys"
            :key="keyObj.key"
            :id="keyObj.key"
            :category="categories[keyObj.key]"
          ></CategoryCard>
        </transition-group>
      </div>
    </template>
    <template v-else>
      <div class="row justify-content-center">
        <div class="col-md-6">
          <h2 v-html="$t('home.welcome')" />
          <p v-html="$t('home.about')"></p>
          <p v-html="$t('home.loginPrompt')"></p>
          <div class="d-flex justify-content-center">
            <div
              class="btn btn-primary"
              @click="$router.push({ name: ROUTE_LOGIN })"
            >
              {{ $t("navigation." + ROUTE_LOGIN) }}
            </div>
            <div
              class="btn btn-secondary ml-3"
              @click="$router.push({ name: ROUTE_REGISTER })"
            >
              {{ $t("navigation." + ROUTE_REGISTER) }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FoodCard from "./food/FoodCard";
import CategoryCard from "./categories/CategoryCard";
import {
  ROUTE_LOGIN,
  ROUTE_REGISTER,
  ROUTE_FOOD,
  ROUTE_CATEGORIES
} from "./../constants";
import { sortObjectKeysBySubProperty } from "./../tools";

export default {
  name: "Home",
  components: {
    FoodCard,
    CategoryCard
  },
  data() {
    return {
      ROUTE_LOGIN,
      ROUTE_REGISTER,
      ROUTE_FOOD,
      ROUTE_CATEGORIES
    };
  },
  computed: {
    ...mapGetters(["food", "categories"]),
    sortedFoodKeys() {
      let keyObj = sortObjectKeysBySubProperty(this.food, {
        by: "updated",
        desc: true
      });
      // limit to 4 items
      keyObj.splice(4);
      return keyObj;
    },
    sortedCategoriesKeys() {
      let keyObj = sortObjectKeysBySubProperty(this.categories, {
        by: "updated",
        desc: true
      });
      // limit to 4 items
      keyObj.splice(4);
      return keyObj;
    }
  }
};
</script>

<style scoped lang="scss">
h3 span {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>
